/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} News_Meta_Twittertitle1Inputs */

const ja_news_meta_twittertitle1 = /** @type {(inputs: News_Meta_Twittertitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN | ニュース・プレスリリース`)
};

const en_news_meta_twittertitle1 = /** @type {(inputs: News_Meta_Twittertitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN - Company News & Press Releases`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN - Company News & Press Releases" |
*
* @param {News_Meta_Twittertitle1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const news_meta_twittertitle1 = /** @type {((inputs?: News_Meta_Twittertitle1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<News_Meta_Twittertitle1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_news_meta_twittertitle1(inputs)
	return en_news_meta_twittertitle1(inputs)
});
export { news_meta_twittertitle1 as "news_meta_twitterTitle" }